import React from "react";
import { cn } from "~/utils";

const SelectionTile = ({ children, onClick, selected }) => (
  <div
    className={cn(
      "flex w-[150px] cursor-pointer rounded border-2 border-transparent bg-white p-2 text-center shadow-sm hover:border-blue-200 hover:transition",
      selected
        ? "cursor-auto border-2 border-blue-300 hover:border-2 hover:border-blue-300"
        : "",
    )}
    onClick={onClick}
  >
    {children}
  </div>
);

const Selection = ({ action, setAction }) => (
  <div>
    <p className="m-0 mb-6 max-w-[600px] text-xs text-slate-400">
      Dr Frost is a registered charity. Subscription fees allow us to continue
      operating as a charity and all fees are invested in improving our
      offering. No subscription is required for individual teachers for up to
      three classes.
    </p>
    <div className="flex select-none flex-wrap gap-4">
      <SelectionTile
        onClick={() => setAction("generate")}
        selected={action === "generate"}
      >
        <div className="m-auto flex flex-col text-center">
          <span className="font-semibold text-slate-600">£600 / year</span>
          <span className="text-xs text-slate-400">(exlcuding VAT)</span>
        </div>
      </SelectionTile>
      <SelectionTile
        onClick={() => setAction("application")}
        selected={action === "application"}
      >
        <div className="m-auto text-sm font-semibold text-slate-600">
          Apply for a discount
        </div>
      </SelectionTile>
    </div>
  </div>
);

export default Selection;
